import { Component, Inject, Input } from '@angular/core';
import { ActionModel, BACKGROUND_TYPE, BackgroundModel, EventsService, GradientDirection } from 'simpo-component-library';

@Component({
  selector: 'app-background-color-editor',
  templateUrl: './background-color-editor.component.html',
  styleUrls: ['./background-color-editor.component.scss']
})
export class BackgroundColorEditorComponent {
  constructor(
    private eventService: EventsService) { }

  selectedTab: 'Theme' | 'Custom' = "Theme";
  @Input() data: any;
  @Input() backgroundData!: BackgroundModel;
  @Input() actionData!: ActionModel
  @Input() componentId?: string;
  backgroundType: BACKGROUND_TYPE[] = ['Solid', 'Gradient']
  GradientDirection = GradientDirection;
  ngOnInit() {
    if (!this.checkSelectedTheme()) {
      this.selectedTab = 'Custom'
    }
  }

  checkSelectedTheme() {
    let foundSelectedTheme = false;

    for (let theme of this.themes) {
      if (theme.color === this.backgroundData?.color && theme.accentColor === this.backgroundData?.accentColor) {
        foundSelectedTheme = true;
        theme.selected = true;
      } else {
        theme.selected = false;
      }
    }

    return foundSelectedTheme;
  }

  themes = [
    {
      id: 1,
      color: '#F8F1E7',
      accentColor: '#1C4324',
      selected: true
    },
    {
      id: 2,
      color: '#FCFAF6',
      accentColor: '#1C4324',
      selected: false
    },
    {
      id: 3,
      color: '#E6EFE8',
      accentColor: '#1C4324',
      selected: false
    },
    {
      id: 4,
      color: '#DDE9E0',
      accentColor: '#1C4324',
      selected: false
    }
  ]

  changeTabs(selectedTab: 'Theme' | 'Custom') {
    if (selectedTab === 'Theme' && this.selectedTab === 'Custom') {
      (this.backgroundData as any)['_savedCustomColor'] = this.backgroundData.color;
      (this.backgroundData as any)['_savedCustomAccentColor'] = this.backgroundData.accentColor;
    } else if (selectedTab === 'Custom' && this.selectedTab === 'Theme') {
      const saved = (this.backgroundData as any)['_savedCustomColor'];
      const savedAccent = (this.backgroundData as any)['_savedCustomAccentColor'];
      if (saved) this.backgroundData.color = saved;
      if (savedAccent) this.backgroundData.accentColor = savedAccent;
    }
    this.selectedTab = selectedTab;
  }

  get isCustomSelected(): boolean {
    return !this.themes.some(t => t.selected);
  }

  selectCustom() {
    const saved = (this.backgroundData as any)['_savedCustomColor'];
    const savedAccent = (this.backgroundData as any)['_savedCustomAccentColor'];
    if (saved) this.backgroundData.color = saved;
    if (savedAccent) this.backgroundData.accentColor = savedAccent;
    this.themes.forEach(t => t.selected = false);
    this.eventService.backgroundImageChangeCheck.emit({ id: this.componentId, data: this.backgroundData });
  }

  selectTheme(id: any) {
    for (let theme of this.themes) {
      if (theme.id === id) {
        theme.selected = true;
        if (this.backgroundData) {
          this.backgroundData.color = theme.color;
          this.backgroundData.accentColor = theme.accentColor;
          this.eventService.backgroundImageChangeCheck.emit({ id: this.componentId, data: this.backgroundData })
        }
      } else {
        theme.selected = false;
      }
    }
  }

  changeBackground() {
    this.eventService.backgroundImageChangeCheck.emit({ id: this.componentId, data: this.backgroundData });
    if (this.data?.background?.showImage) {
      this.eventService.colorOverlayChangeChecks.emit({
        id: this.componentId,
        data: this.backgroundData,
      });
    }
  }

  changeAccentColor() {
    for (let button of this.actionData.buttons) {
      this.eventService.buttonStyleChangeChecks.emit({ id: this.componentId + button.id, style: button.styles, backgroundInfo: this.backgroundData });
    }
  }

  changeBackgroundType(type: any) {
    this.backgroundData.backgroundGradientDirection = type;
    this.changeBackground();
  }

  changeAccentGradientDirection(type: any) {
    this.backgroundData.gradientDirection = type;
    this.changeAccentColor();
  }

  getBackgroundDirection(direction) {
    if (direction == 'DOWN') {
      return '180deg'
    }
    else if (direction == 'RIGHT') {
      return '90deg'
    } else if (direction == 'DIAGONAL_RIGHT') {
      return '45deg'
    }
    else {
      return '315deg'
    }
  }

}
